import { Story } from '../../DocTypes';

export const dataDrivenIconStory: Story = {
  title: 'Data driven icons',
  description: 'List with items having an icon and its accent driven by the lists data',
  coreComponent: {
    html: `<tag-list
    left-icon-field='icon'
    left-icon-title-field='icon'
    primary-field='name'
    right-field-1='name'
    right-field-1-icon-field='rightIcon'
    right-field-1-icon-accent-field='rightIconColor'>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      { name: 'Jordan Pickford', icon: 'Building', rightIcon: 'HourglassFull', rightIconColor: 'keppel' },
      { name: 'Kyle Walker', icon: 'ArrowFF', rightIcon: 'CircleTick', rightIconColor: 'tango' },
      { name: 'John Stones', icon: 'Star', rightIcon: 'Anchor', rightIconColor: 'mojo' },
      { name: 'Harry Maguire', icon: 'Anchor', rightIcon: 'Building', rightIconColor: 'surf' },
      { name: 'Luke Shaw', icon: 'Conversation', rightIcon: 'ArrowFF', rightIconColor: 'navy' }
    ]);
  });
    `,
  },
  // coreComponent_v3: {
  //   html: `<tag3-list
  //   left-icon-field='icon'
  //   left-icon-title-field='icon'
  //   primary-field='name'
  //   right-field-1='name'
  //   right-field-1-icon-field='rightIcon'
  //   right-field-1-icon-accent-field='rightIconColor'>
  // </tag3-list>`,
  //   js: `var tagList = document.querySelector('tag3-list');
  //   tagList.setData([
  //     { name: 'Jordan Pickford', icon: 'Building', rightIcon: 'HourglassFull', rightIconColor: 'keppel' },
  //     { name: 'Kyle Walker', icon: 'ArrowFF', rightIcon: 'CircleTick', rightIconColor: 'tango' },
  //     { name: 'John Stones', icon: 'Star', rightIcon: 'Anchor', rightIconColor: 'mojo' },
  //     { name: 'Harry Maguire', icon: 'Anchor', rightIcon: 'Building', rightIconColor: 'surf' },
  //     { name: 'Luke Shaw', icon: 'Conversation', rightIcon: 'ArrowFF', rightIconColor: 'navy' }
  //   ]);
  //   `,
  // },
  reactWrapper: {
    jsx: `<TagList
    leftIconField='icon'
    leftIconTitleField='icon'
    primaryField='name'
    rightField1='name'
    rightField1IconField='rightIcon'
    rightField1IconAccentField='rightIconColor'
    data={[
      { name: 'Jordan Pickford', icon: 'Building', rightIcon: 'HourglassFull', rightIconColor: 'keppel' },
      { name: 'Kyle Walker', icon: 'ArrowFF', rightIcon: 'CircleTick', rightIconColor: 'tango' },
      { name: 'John Stones', icon: 'Star', rightIcon: 'Anchor', rightIconColor: 'mojo' },
      { name: 'Harry Maguire', icon: 'Anchor', rightIcon: 'Building', rightIconColor: 'surf' },
      { name: 'Luke Shaw', icon: 'Conversation', rightIcon: 'ArrowFF', rightIconColor: 'navy' }
    ]}
  />`,
  },
};
